// TanStack Query için query key'lerini tanımla
export const QueryKeys = {
  USER: {
    all: ["user"] as const,
    detail: () => [...QueryKeys.USER.all, "detail"] as const,
    credits: () => [...QueryKeys.USER.all, "credits"] as const,
  },
  QUERY: {
    all: ["query"] as const,
    byText: (text: string) => [...QueryKeys.QUERY.all, text] as const,
  },
  CONVERSATIONS: {
    all: ["conversations"] as const,
    list: ["conversations", "list"] as const,
    byId: (id: string) => [...QueryKeys.CONVERSATIONS.all, id] as const,
    messages: (id: string) =>
      [...QueryKeys.CONVERSATIONS.byId(id), "messages"] as const,
  },
  ADDRESS: {
    all: ["address"] as const,
    byId: (id: string) => ["address", id] as const,
  },
  PRICING: {
    all: ["pricing"] as const,
    plans: () => [...QueryKeys.PRICING.all, "plans"] as const,
    byType: (type: string) =>
      [...QueryKeys.PRICING.all, "plans", type] as const,
  },
  CART: {
    all: ["cart"] as const,
    items: () => [...QueryKeys.CART.all, "items"] as const,
    byId: (id: string) => [...QueryKeys.CART.all, id] as const,
  },
  CARDS: {
    all: ["cards"] as const,
    saved: () => [...QueryKeys.CARDS.all, "saved"] as const,
  },
  CHECKOUT: {
    all: ["checkout"] as const,
    cardInfo: (bin: string) =>
      [...QueryKeys.CHECKOUT.all, "cardInfo", bin] as const,
    agreements: (
      offerId: string | null,
      addressKey: string,
      region: string
    ) =>
      [
        ...QueryKeys.CHECKOUT.all,
        "agreements",
        offerId,
        addressKey,
        region,
      ] as const,
  },
  SITE_CONFIGS: {
    all: ["siteConfigs"] as const,
    categories: () => [...QueryKeys.SITE_CONFIGS.all, "categories"] as const,
  },
  FAVORITE_PRODUCTS: {
    all: ["favoriteProducts"] as const,
    list: (page: number, limit: number, sortBy?: string) =>
      [
        ...QueryKeys.FAVORITE_PRODUCTS.all,
        "list",
        page,
        limit,
        sortBy ?? null,
      ] as const,
  },
  LLM_MODEL_FAVORITES: {
    all: ["llmModelFavorites"] as const,
    list: () => [...QueryKeys.LLM_MODEL_FAVORITES.all, "list"] as const,
  },
  LLM_MODEL_COMMENTS: {
    all: ["llmModelComments"] as const,
    byModelId: (modelId: string) =>
      [...QueryKeys.LLM_MODEL_COMMENTS.all, modelId] as const,
  },
  LLM_MODEL_RATING: {
    all: ["llmModelRating"] as const,
    byModelId: (modelId: string) =>
      [...QueryKeys.LLM_MODEL_RATING.all, modelId] as const,
  },
  AGREEMENTS: {
    all: ["agreements"] as const,
    byName: (name: string) => [...QueryKeys.AGREEMENTS.all, name] as const,
  },
  REWARDS: {
    all: ["rewards"] as const,
    balances: () => [...QueryKeys.REWARDS.all, "balances"] as const,
    history: (page: number, limit: number) =>
      [...QueryKeys.REWARDS.all, "history", page, limit] as const,
    convertPreview: (amount: number, connectionId?: string) =>
      [
        ...QueryKeys.REWARDS.all,
        "convert-preview",
        amount,
        connectionId ?? "default",
      ] as const,
  },
  COSMOPOINTS: {
    all: ["cosmopoints"] as const,
    programs: () => [...QueryKeys.COSMOPOINTS.all, "programs"] as const,
    connections: () => [...QueryKeys.COSMOPOINTS.all, "connections"] as const,
  },
} as const;
